module.exports = __webpack_public_path__ + "img/snacks2.e0a90f77.jpg";